import { render, staticRenderFns } from "./ModalPackaging.vue?vue&type=template&id=2c7dd326&"
import script from "./ModalPackaging.vue?vue&type=script&lang=js&"
export * from "./ModalPackaging.vue?vue&type=script&lang=js&"
import style0 from "./ModalPackaging.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports